/**
 * frontend/src/lib/creatorsList.js — the public Discover artist list.
 *
 * Plain fetch (no Authorization header): the list is public, so there is no CORS preflight
 * and no token check on the server. Pages are cached in memory for 20 s, and the first page
 * can be prefetched while the app is still loading the signed-in profile, so the grid does
 * not wait for the profile round trip first.
 */

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001';
const TTL_MS = 20 * 1000;
const cache = new Map();   // key → { at, promise }

export function fetchCreatorsPage(page = 1, sort = 'newest') {
  const s = sort === 'fans' ? 'fans' : 'newest';
  const key = `${s}:${page}`;
  const hit = cache.get(key);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.promise;
  const promise = fetch(`${API_BASE}/api/creators?page=${page}&sort=${s}`)
    .then((res) => {
      if (!res.ok) throw new Error('Failed to load creators');
      return res.json();
    })
    .catch((err) => { cache.delete(key); throw err; });
  cache.set(key, { at: Date.now(), promise });
  return promise;
}

/** Start loading the first page now (called at app start on /player/discover and /creators). */
export function prefetchCreators() {
  fetchCreatorsPage(1, 'newest').catch(() => {});
}
